import React, { useState } from "react";
import { NewNavbar, BreadCrumbsNew, NewFooter } from "../../components";
import { Form, Input, Select, message } from "antd";
import "./index.css";
import { post } from "../../services/ApiService";
import { useNavigate } from "react-router-dom";

const { Option } = Select;

const TokenPrescription = () => {
  const breadcrumbs = [
    { label: "Home", path: "/" },
    { label: "Prescription" },
  ];
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const { authCode, day, month, year } = values;
      if (!day || !month || !year) {
        message.error("Please complete your date of birth");
        setLoading(false);
        return;
      }

      // Create date in UTC to avoid timezone issues
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const monthIndex = monthNames.indexOf(month);

      // Create date in UTC (time set to noon to avoid timezone shifting)
      const dob = new Date(Date.UTC(year, monthIndex, day, 12, 0, 0));

      if (isNaN(dob)) {
        message.error("Invalid date of birth");
        setLoading(false);
        return;
      }

      // Send as ISO string or timestamp
      const payload = {
        authCode,
        dob: dob.toISOString() // Send as ISO string
      };

      const res = await post("api/prescriptions/auth", payload);

      if (res?.success) {
        navigate(`/prescription/${authCode}`);
      } else {
        message.error(res?.error || "No prescription found");
      }
    } catch (error) {
      console.error(error);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="weightloss-wraper">
      <div className="breadcrumnb-img-bg pres_bg_img">
        <div className="container">
          <NewNavbar />
          <BreadCrumbsNew breadcrumbs={breadcrumbs} title={"Prescription Token"} />
        </div>
      </div>
      <div className="token_section my-3 py-3">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h3>Welcome to My Private Chemist</h3>
              <p>
                Download Electronically signed private prescription here.
                <br />
                Fully compliant with{" "}
                <a href="#">
                  Human Medicines Regulation, Directives 2012/52/EU & Directive
                  2011/24/EU.
                </a>
              </p>
              <p>
                UK pharmacists can dispense EU prescriptions by following the{" "}
                <a href="#">
                  Prescriptions issued in the EEA and Switzerland: guidance for
                  pharmacists
                </a>
              </p>
            </div>
          </div>

          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            className="mt-4"
          >
            <div className="row justify-content-center mt-10">
              <div className="col-lg-5 mt-auto">
                <Form.Item
                  name="authCode"
                  label="Authorisation code"
                  required
                  rules={[
                    { required: true, message: "Please enter authorisation code" },
                  ]}
                >
                  <Input type="text" placeholder="Enter authorisation code here" />
                </Form.Item>
              </div>
            </div>

            {/* Date of Birth Fields */}
            <div className="row justify-content-center">
              <div className="col-lg-5 mb-10 mt-auto">
                <label>Date of Birth</label>
                <div className="row">
                  <div className="col-lg-4">
                    <Form.Item
                      name="day"
                      rules={[{ required: true, message: "Select day" }]}
                    >
                      <Select placeholder="Day">
                        {Array.from({ length: 31 }, (_, i) => {
                          const d = String(i + 1).padStart(2, "0");
                          return (
                            <Option key={d} value={d}>
                              {d}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-lg-4">
                    <Form.Item
                      name="month"
                      rules={[{ required: true, message: "Select month" }]}
                    >
                      <Select placeholder="Month">
                        {[
                          "Jan",
                          "Feb",
                          "Mar",
                          "Apr",
                          "May",
                          "Jun",
                          "Jul",
                          "Aug",
                          "Sep",
                          "Oct",
                          "Nov",
                          "Dec",
                        ].map((m) => (
                          <Option key={m} value={m}>
                            {m}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-lg-4">
                    <Form.Item
                      name="year"
                      rules={[{ required: true, message: "Select year" }]}
                    >
                      <Select placeholder="Year">
                        {Array.from({ length: 100 }, (_, i) => {
                          const y = 2026 - i;
                          return (
                            <Option key={y} value={y}>
                              {y}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
              </div>
            </div>

            {/* Submit button */}
            <div className="row justify-content-center">
              <div className="col-lg-5 mt-10 mb-10">
                <button
                  type="submit"
                  disabled={loading}
                  className="btncust w-auto activebg cursor-pointer btncust-light mx-auto p-0"
                >
                  <span className="text-white btn_pres px-10 py-3 d-inline-flex">
                    {loading ? "Processing..." : "Find Prescription"}
                  </span>
                </button>
              </div>
            </div>
          </Form>

          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h5>PRIVATE and CONFIDENTIAL</h5>
              <p>
                <small>It is a criminal offense to misuse this software application.</small>
              </p>
              <p>
                <small>
                  Do not enter token code if you do not have permission to access the
                  information from the patient or their chosen representative.
                </small>
              </p>
            </div>
          </div>
        </div>
      </div>
      <NewFooter />
    </div>
  );
};

export { TokenPrescription };
